import "esbuild-css-modules-plugin-ns-css:src/ui/tooltip.module.css";

export default {
  "tooltip": "tooltip-module__tooltip_qonKzG__0230",
  "tooltipInitiator": "tooltip-module__tooltip-initiator_qonKzG__0230",
  "tooltipItem": "tooltip-module__tooltip-item_qonKzG__0230"
};
      